import i18next from 'i18next';

import commonEs from './common/es/index.json';
import commonEn from './common/en/index.json';
import commonPt from './common/pt/index.json';
import commonFr from './common/fr/index.json';
import commonDe from './common/de/index.json';
import commonNl from './common/nl/index.json';
import commonDa from './common/da/index.json';
import commonSv from './common/sv/index.json';
import commonNo from './common/no/index.json';
import commonRu from './common/ru/index.json';
import commonPl from './common/pl/index.json';
import commonIt from './common/it/index.json';
import commonCs from './common/cs/index.json';
import commonRo from './common/ro/index.json';
import commonFi from './common/fi/index.json';
import commonIs from './common/is/index.json';
import commonTr from './common/tr/index.json';
import commonCy from './common/cy/index.json';
import commonAr from './common/ar/index.json';
import commonZhCn from './common/zh-cn/index.json';
import commonHi from './common/hi/index.json';
import commonJa from './common/ja/index.json';
import commonKo from './common/ko/index.json';

import ekEn from './ek/en/index.json';
import { LanguageNamespaces, LANGUAGE_NAMESPACE } from '@constants/language';

i18next.init({
  interpolation: { escapeValue: false },
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: LANGUAGE_NAMESPACE,
  fallbackNS: LanguageNamespaces.Common,
  ns: [LanguageNamespaces.Common, LANGUAGE_NAMESPACE],
  resources: {
    en: {
      common: commonEn,
      ek: ekEn,
    },
    es: {
      common: commonEs,
    },
    pt: {
      common: commonPt,
    },
    fr: {
      common: commonFr,
    },
    de: {
      common: commonDe,
    },
    nl: {
      common: commonNl,
    },
    da: {
      common: commonDa,
    },
    sv: {
      common: commonSv,
    },
    no: {
      common: commonNo,
    },
    ru: {
      common: commonRu,
    },
    pl: {
      common: commonPl,
    },
    it: {
      common: commonIt,
    },
    cs: {
      common: commonCs,
    },
    ro: {
      common: commonRo,
    },
    fi: {
      common: commonFi,
    },
    is: {
      common: commonIs,
    },
    tr: {
      common: commonTr,
    },
    cy: {
      common: commonCy,
    },
    ar: {
      common: commonAr,
    },
    'zh-CN': {
      common: commonZhCn,
    },
    hi: {
      common: commonHi,
    },
    ja: {
      common: commonJa,
    },
    ko: {
      common: commonKo,
    },
  },
});

export default i18next;
